/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Solution_Deprecated_BadgeInputs */

const en_task_solution_deprecated_badge = /** @type {(inputs: Task_Solution_Deprecated_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deprecated`)
};

const pt_br2_task_solution_deprecated_badge = /** @type {(inputs: Task_Solution_Deprecated_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descontinuada`)
};

/**
* | output |
* | --- |
* | "Deprecated" |
*
* @param {Task_Solution_Deprecated_BadgeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_solution_deprecated_badge = /** @type {((inputs?: Task_Solution_Deprecated_BadgeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Solution_Deprecated_BadgeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_solution_deprecated_badge(inputs)
	return pt_br2_task_solution_deprecated_badge(inputs)
});